import * as React from 'react';
import { useContext } from 'react';

export interface ITrackingContextValue {
  getTimeFromInit: (initTime?: number) => number;
}

const defaultTrackingContextValue: ITrackingContextValue = {
  getTimeFromInit: () => 0,
};

const TrackingContext = React.createContext<ITrackingContextValue>(defaultTrackingContextValue);

export const useTrackingContext = () => useContext(TrackingContext);

export const TrackingContextProvider = ({ children }: React.PropsWithChildren<object>) => {
  const initTime = React.useRef(new Date().getTime());

  useSubscribeToInitTimeReset(() => {
    initTime.current = new Date().getTime();
  });

  const value = React.useMemo(
    () => ({
      getTimeFromInit: (time = initTime.current) => new Date().getTime() - time,
    }),
    [],
  );

  return <TrackingContext.Provider value={value}>{children}</TrackingContext.Provider>;
};

const useSubscribeToInitTimeReset = (callback: () => void) => {
  const memoizedCallback = React.useRef(callback);
  React.useEffect(() => {
    memoizedCallback.current = callback;
  }, [callback]);
};

TrackingContextProvider.useSubscribeToInitTimeReset = useSubscribeToInitTimeReset;
